import { render, staticRenderFns } from "./AmountDetailOrder.vue?vue&type=template&id=5b4ff782&"
import script from "./AmountDetailOrder.vue?vue&type=script&lang=ts&"
export * from "./AmountDetailOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports